
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { ApiService } from 'app/api.service';

@Injectable({
  providedIn: 'root'
})
export class FinancialYearService {
  private selectedYearsSubject = new BehaviorSubject<string[]>([]);
  selectedYears$ = this.selectedYearsSubject.asObservable();

  private availableYearsSubject = new BehaviorSubject<string[]>([]);
  availableYears$ = this.availableYearsSubject.asObservable();

  constructor(private apiService: ApiService) {
    this.initializeFinancialYears();
  }

  initializeFinancialYears(): void {
    try {
      const loginData = JSON.parse(localStorage.getItem('data') || '{}');
      const parsedAccess = JSON.parse(loginData.access || '{}');
      const access = Array.isArray(parsedAccess) ? {} : parsedAccess;
      const accessList = JSON.parse(localStorage.getItem('accesslist') || '[]');

      const tenantId = accessList?.[0]?.config?.tenant_id;
      const obDate = tenantId ? access?.[tenantId]?.ob_date : null;

      if (obDate) {
        this.setupFinancialYears(obDate);
        return;
      }

      const host = window.location.hostname;
      console.log('host', window.location.hostname);

      this.apiService.Companydetails(host as any).subscribe({
        next: (res: any) => {
          const companyObDate = res?.ob_date;
          companyObDate ? this.setupFinancialYears(companyObDate) : this.resetFinancialYears();
        },
        error: (err) => {
          console.error('Failed to fetch company details:', err);
          this.resetFinancialYears();
        }
      });
    } catch (error) {
      console.error('Failed to initialize financial years:', error);
      this.resetFinancialYears();
    }
  }

  private resetFinancialYears(): void {
    this.availableYearsSubject.next([]);
    this.selectedYearsSubject.next([]);
  }

  private setupFinancialYears(obDate: string): void {
    const date = new Date(obDate);
    const fyStart = date.getMonth() >= 3
      ? date.getFullYear()
      : date.getFullYear() - 1;

    const availableYears = this.generateYearsList(fyStart);
    this.availableYearsSubject.next(availableYears);
    this.selectedYearsSubject.next(availableYears.length ? [availableYears[0]] : []);
}

  private generateYearsList(startYear: number): string[] {
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth();
    const endYear = currentMonth >= 3 ? currentYear : currentYear - 1;
    
    const years: string[] = [];
    for (let y = startYear; y <= endYear; y++) {
      years.push(`${y}-${y + 1}`);
    }
    return years.reverse();
  }

  setFinancialYears(years: string[]): void {
    this.selectedYearsSubject.next(years);
  }

  getSelectedYears(): string[] {
    return this.selectedYearsSubject.value;
  }
}
